import { useState } from 'react';
export function useGlobalContext() {
    var _a = useState(false), loading = _a[0], setLoading = _a[1];
    var _b = useState(null), loadingText = _b[0], setLoadingText = _b[1];
    return {
        loading: loading,
        setLoading: setLoading,
        loadingText: loadingText,
        setLoadingText: setLoadingText,
    };
}
